// import axios from 'axios'
// const baseURL = "http://localhost:8001/api/produtos";
//
// const tabelaPreco =
// axios.get(baseURL).then((response) => {
//   // setPost(response.data);
//   console.log('response.data ', response.data);
// })

const tabelaPreco = [
  { name: 'ovo-frito', descricao: 'Ovos frito', preco: 14.9, qtde: 0, subtotal: 0 },//index 0
  { name: 'fast-food', descricao: 'Hamburger fast food', preco: 15.99, qtde:0, subtotal: 0  },
  { name: 'sanduiche', descricao: 'Sanduíche', preco: 14.20, qtde: 0, subtotal: 0  },
  { name: 'sanduiche-super', descricao: 'Sanduíche super', preco: 19.70, qtde: 0, subtotal: 0  }
]
export default tabelaPreco
